import { render, staticRenderFns } from "./GenericNameLabel.vue?vue&type=template&id=27f9be78&scoped=true"
import script from "./GenericNameLabel.vue?vue&type=script&lang=js"
export * from "./GenericNameLabel.vue?vue&type=script&lang=js"
import style0 from "./GenericNameLabel.vue?vue&type=style&index=0&id=27f9be78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f9be78",
  null
  
)

export default component.exports